module.exports = __webpack_public_path__ + "img/22-the-social-city-aspiration.f27b7e3b.jpg";